<style lang="stylus">

.keyboard-template {
    .digits {
        width: 250px;
        margin: 1em auto;
        text-align: center;
    }
    .digit {
        margin: 0.3em;
    }
}

</style>

<template lang="html">

<div class="keyboard-template">
    <div class="digits">
        <template v-for="n in 12">
            <button class="digit fab" v-if="n <= 9" @click="keyPress(n)">{{n}}</button>
            <button class="digit fab" v-if="n === 10" @click="keyPress('erase')"><i class="icon-backspace"></i></button>
            <button class="digit fab" v-if="n === 11" @click="keyPress(0)">0</button>
            <button class="digit fab" v-if="n === 12" @click="keyPress('valid')"><i class="icon-check"></i></button>
        </template>
    </div>
</div>

</template>

<script>
export default {
    methods: {
        keyPress(value) {
            this.$emit('keyboardPress', value)
        }
    }
}
</script>



// WEBPACK FOOTER //
// Keyboard.vue?047077d8